import _ from 'lodash';
import React, { useState } from 'react';
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../common/components/form/input/containers/input.container';
import storePersist from '../../../../redux/storePersist';
import * as R from 'ramda';


export const OBNDBNBizBasicInfoComponent = ({openNetworkRegistries,bizNetTypes,
  oBNDBNBizsList, dbnpregistries, deliveryPreference, accountType, id, selectedOBNDBNBiz, shippingTypes,
  shippingProviders, accounts, fetchAcount, obnDBNBiz, onFormChange, shippingOptionList
}: any) => {
  const statesItems = storePersist?.get("states")?.current?.items;
    const countriesItems = storePersist?.get("countries")?.current?.items;
  const dayEnum: any = [
    { Description: 'Sunday', Value: 1 },
    { Description: 'Monday', Value: 2 },
    { Description: 'Tuesday', Value: 3 },
    { Description: 'Wednesday', Value: 4 },
    { Description: 'Thursday', Value: 5 },
    { Description: 'Friday', Value: 6 },
    { Description: 'Saturday', Value: 7 }
  ]
 const [
    stateValues,
    setStateValues
    ] = useState<any>([])
  
     const handleFilterToStates = (value: any) => {
     onFormChange({
       value: value,
       field: 'CountryId'
     });
   
     if (value) {
       const filterStates: any = R.filter(
         (item: any) => item.CountryId === value,
         statesItems
       );
       if (filterStates.length) {
         setStateValues(filterStates);
       } else {
         setStateValues(statesItems);
       }
     } else {
       setStateValues([]);
     }
   };
  const timeSlots = [
    {
      Disabled: false,
      Selected: false,
      Text: '10 AM to 12 PM',
      Description: '10 AM to 12 PM',
      Value: 10
    },
    {
      Disabled: false,
      Selected: false,
      Text: '12 PM to 2 PM',
      Description: '12 PM to 2 PM',
      Value: 20
    },
    {
      Disabled: false,
      Selected: false,
      Text: '2 PM to 4 PM',
      Description: '2 PM to 4 PM',
      Value: 30
    },
    {
      Disabled: false,
      Selected: false,
      Text: '4 PM to 6 PM',
      Description: '4 PM to 6 PM',
      Value: 40
    },
    {
      Disabled: false,
      Selected: false,
      Text: '24 Hrs',
      Description: '24 Hrs',
      Value: 50
    }
  ]

  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            {/* <InputContainer
              label="Account Type"
              labelField="Text"
              list={accountType}
              onValueChange={(event: any, newValue: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'AccountTypeId'
                });
              }}
              optionName='Choose Account Type'
              type="select"
              value={obnDBNBiz?.AccountTypeId}
              valueField="Value"
            />
            {obnDBNBiz?.AccountTypeId ?
              <InputContainer
                label="Account Name"
                labelField="Name"
                list={accounts}
                onValueChange={(event: any, newValue: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'AccountId'
                  });
                }}
                optionName='Choose Account'
                type="select"
                value={obnDBNBiz?.AccountId}
                valueField="AccountId"
              />
              : null
            } */}
              <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'Name'
                });
              }}
              type="text"
              value={obnDBNBiz?.Name}
            />

              <InputContainer
              label="Email"
              name="Email"
              onValueChange={(event: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'Email'
                });
              }}
              type="text"
              value={obnDBNBiz?.Email}
            />

              <InputContainer
              label="PhoneNumber"
              name="PhoneNumber"
              onValueChange={(event: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'PhoneNumber'
                });
              }}
              type="text"
              value={obnDBNBiz?.PhoneNumber}
            />
            <InputContainer
              label="Open Network Registry"
              labelField="BusinessName"
              list={openNetworkRegistries}
              onValueChange={(event: any, newValue: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'OBNRegistryId'
                });
              }}
              optionName='Choose Open Network Registries'
              type="select"
              value={obnDBNBiz?.OBNRegistryId}
              valueField="Id"
            />

             <InputContainer
              label="BizNet Types"
              labelField="Name"
              list={bizNetTypes}
               onValueChange={(newValue: any) => {
                    const valueData: any = newValue.map((option: any) => option?.value || '');
                    onFormChange({
                      value: valueData,
                      field: 'BizNetTypeIds'
                    });
                  }}
                  type="multiselect"
              value={obnDBNBiz?.BizNetTypeIds}
              valueField="Id"
            />
            <InputContainer
              label="Accept Order By Default Enabled"
              name="IsAcceptOrderByDefaultEnabled"
              onValueChange={(event: any) => {
                onFormChange({
                  value: event,
                  field: 'IsAcceptOrderByDefaultEnabled'
                });
              }}
              type="checkbox"
              value={obnDBNBiz?.IsAcceptOrderByDefaultEnabled}
            />
            <InputContainer
              label="Direct Shipment Enabled"
              name="IsDirectShipmentEnabled"
              onValueChange={(event: any) => {
                onFormChange({
                  value: event,
                  field: 'IsDirectShipmentEnabled'
                });
              }}
              type="checkbox"
              value={obnDBNBiz?.IsDirectShipmentEnabled}
            />
            <InputContainer
              label="UkId"
              name="UkId"
              onValueChange={(event: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'UkId'
                });
              }}
              type="text"
              value={obnDBNBiz?.UkId}
            />
            <InputContainer
              label="Delivery Preference"
              labelField="Text"
              list={deliveryPreference}
              onValueChange={(event: any, newValue: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'Delivery_preference'
                });
              }}
              optionName='Choose DeliveryPreference'
              type="select"
              value={obnDBNBiz?.Delivery_preference}
              valueField="Text"
            />
            {obnDBNBiz?.Delivery_preference === 'Network' &&
              <div>
                <InputContainer
                  label="LogisticProviderAccount Name"
                  labelField="AccountName"
                  list={shippingProviders}
                  onValueChange={(newValue: any) => {
                    const valueData: any = newValue.map((option: any) => option?.value || '');
                    onFormChange({
                      value: valueData,
                      field: 'PreferredLogisticProviderAccountIds'
                    });
                  }}
                  type="multiselect"
                  valueField="AccountId"
                  value={obnDBNBiz?.PreferredLogisticProviderAccountIds}
                />
                {/* <InputContainer
                  label="Preferred DBNLogistics Transporter Mapping"
                  labelField="AccountInfo.AccountName"
                  list={oBNDBNBizsList}
                  onValueChange={(newValue: any) => {
                    const valueData: any = newValue.map((option: any) => option?.value || '');
                    onFormChange({
                      value: valueData,
                      field: 'PreferredDBNLogisticsTransporterMapping'
                    });
                  }}
                  type="multiselect"
                  valueField="AccountInfo.AccountId"
                  value={obnDBNBiz?.PreferredDBNLogisticsTransporterMapping}
                /> */}
              </div>
            }
            {/* <InputContainer
              label="Shipping Type"
              labelField="ShippingTypeName"
              list={shippingTypes}
              onValueChange={(event: any, newValue: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'ShippingTypeId'
                });
              }}
              optionName='Choose ShippingType'
              type="select"
              value={obnDBNBiz?.ShippingTypeId}
              valueField="Id"
            /> */}
            <InputContainer
              label="Shipping Options"
              labelField="Text"
              list={shippingOptionList}
              onValueChange={(newValue: any) => {
                const valueData: any = newValue.map((option: any) => option?.value || '');
                onFormChange({
                  value: valueData,
                  field: 'ShippingOptionIds'
                });
              }}
              type="multiselect"
              valueField="Value"
              value={obnDBNBiz?.ShippingOptionIds}
            />
            {/* <InputContainer
              label="DBNP Registry Name"
              labelField="name_of_authorised_signatory"
              list={dbnpregistries}
              onValueChange={(event: any, newValue: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'DBNPRegistryId'
                });
              }}
              optionName="Choose DBNP Registry"
              type="select"
              value={obnDBNBiz?.DBNPRegistryId}
              valueField="Id"
            /> */}
            <InputContainer
              label="Std Code"
              name="Stdcode"
              onValueChange={(event: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'Stdcode'
                });
              }}
              type="text"
              value={obnDBNBiz?.Stdcode}
            />
            <InputContainer
              label="GPS"
              name="gps"
              onValueChange={(event: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'gps'
                });
              }}
              type="text"
              value={selectedOBNDBNBiz?.gps}
            />
            <InputContainer
              label="Radius Unit"
              name="unit"
              onValueChange={(event: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'unit'
                });
              }}
              type="text"
              value={selectedOBNDBNBiz?.unit}
            />
            <InputContainer
              label="Radius Value"
              name="value"
              onValueChange={(event: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'value'
                });
              }}
              type="text"
              value={selectedOBNDBNBiz?.value}
            />
            <div>   <InputContainer
              label="Days"
              labelField="Description"
              list={dayEnum}
              onValueChange={(newValue: any) => {
                const valueData: any = newValue.map((option: any) => option?.value || '');
                onFormChange({
                  value: valueData,
                  field: 'days'
                });
              }}
              type="multiselect"
              valueField="Value"
              value={selectedOBNDBNBiz?.days}
            />

            </div>
            <div>
              <InputContainer
                label="Holidays"
                labelField="Description"
                list={dayEnum}
                onValueChange={(newValue: any) => {
                  const valueData: any = newValue.map((option: any) => option?.value || '');
                  onFormChange({
                    value: valueData,
                    field: 'holidays'
                  });
                }}
                type="multiselect"
                valueField="Description"
                value={selectedOBNDBNBiz?.holidays}
              />
            </div>
            <InputContainer
              label="Frequency"
              name="frequency"
              onValueChange={(event: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'frequency'
                });
              }}
              type="text"
              value={selectedOBNDBNBiz?.frequency}
            />
            <div>
              <InputContainer
                label="Times"
                labelField="Description"
                list={timeSlots}
                onValueChange={(newValue: any) => {
                  const valueData: any = newValue.map((option: any) => option?.value || '');
                  onFormChange({
                    value: valueData,
                    field: 'times'
                  });
                }}
                type="multiselect"
                valueField="Description"
                value={selectedOBNDBNBiz?.times}
              />
            </div>
            <InputContainer
              label="Range Start"
              name="start"
              onValueChange={(event: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'start'
                });
              }}
              type="text"
              value={selectedOBNDBNBiz?.start}
            />
            <InputContainer
              label="Range End"
              name="end"
              onValueChange={(event: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'end'
                });
              }}
              type="text"
              value={selectedOBNDBNBiz?.end}
            />
            <InputContainer
              label="Currently Servicing"
              name="CurrentlyServicing"
              onValueChange={(event: any) => {
                onFormChange({
                  value: event,
                  field: 'CurrentlyServicing'
                });
              }}
              type="checkbox"
              value={obnDBNBiz?.CurrentlyServicing}
            />
            <InputContainer
              label="Use Settings From ConfigFile"
              name="UseSettingsFromConfigFile"
              onValueChange={(event: any) => {
                onFormChange({
                  value: event,
                  field: 'UseSettingsFromConfigFile'
                });
              }}
              type="checkbox"
              value={obnDBNBiz?.UseSettingsFromConfigFile}
            />
            {/* {id !== '0' &&
              <InputContainer
                isDisabled
                label="OrganizationUnit Name"
                name="OrganizationUnit Name"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'OwnedByOUName'
                  });
                }}
                type="text"
                value={obnDBNBiz?.OwnedByOUName}
              />
            }
            {id !== '0' &&
              <InputContainer
                isDisabled
                label="OrganizationUnit Account Name"
                name="OrganizationUnit Name"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'OwnedByOUAccountName'
                  });
                }}
                type="text"
                value={obnDBNBiz?.OwnedByOUAccountName}
              /> */}
            {/* } */}
          </div>
        }
        expandedPanel="obnDBNBiz"
        headerTitle="Biz Information"
      />
 <AccordionContainer
              child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                  <InputContainer
                            isRequired
                               label="Address"
                               name="Address"
                               onValueChange={(event: any) => {
                      onFormChange({
                        value: event.target.value,
                        field: 'Address'
                      });
                    }}
                               type="text"
                               value={obnDBNBiz?.Address}
                           />
                  <InputContainer
                            isRequired
                               label="City"
                               name="City"
                               onValueChange={(event: any) => {
                      onFormChange({
                        value: event.target.value,
                        field: 'City'
                      });
                    }}
                               type="text"
                               value={obnDBNBiz?.City}
                           />

                            
                              
                              <InputContainer
                              isRequired
                                         label="Country Name"
                                         labelField="Name"
                                         list={countriesItems}
                                         onValueChange={(event: any, newValue: any) => {
                                           handleFilterToStates(event.target.value);
                                         }}
                            optionName='Choose Country'
                                         type="select"
                                         value={obnDBNBiz?.CountryId}
                                         valueField="Id"
                                     />
                                     <InputContainer
                                     isRequired
                                          label="State Name"
                                          labelField="Name"
                                          list={stateValues}
                                          onValueChange={(event: any, newValue: any) => {
                                            onFormChange({
                        value: event.target.value,
                        field: 'StateProvinceId'
                      });
                                          }}
                             optionName='Choose State'
                                          type="select"
                                          value={obnDBNBiz?.StateProvinceId}
                                          valueField="Id"
                                      />
                </div>
              }
              expandedPanel="Address Information"
              headerTitle="Address Information"
            />
    </>
  )
}

export default OBNDBNBizBasicInfoComponent;
